import { React } from 'react';
import Auxiliary from '../../../hoc/Auxiliary';
import InfoBlockIcon from '../InfoBlockIcon/InfoBlockIcon';
import { Trans } from 'react-i18next';
// import AccordionItem from './AccordionItem';

const TextBlock = props => {

    let faqs = props.faqs;
    let faqsKeys = Object.keys(faqs);

    let displayFaqs = faqsKeys.map(key => {
        return (
            <InfoBlockIcon
                title={
                    <Trans
                        t={props.t}
                        i18nKey={faqs[key]['title']}
                        components={{ italic: <i></i> }}
                    />
                }
                text={
                    <Trans
                        t={props.t}
                        i18nKey={faqs[key]['text']}
                        components={{ italic: <i></i> }}
                    />
                }
                noIcon
            />
            // <AccordionItem
            //     title={faqs[key]['title']}
            //     text={faqs[key]['text']}
            //     key={key}
            // />
        )
    })

    return (
        <Auxiliary>
            {displayFaqs}
        </Auxiliary>
    );
}

export default TextBlock;
